import React from "react";
import { Button } from "antd";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import ReactGA from "react-ga4";
import config from "appConfig";

import styles from "./ownAdBanner.scss";
import { PageRoute, START_PAGE_PARAM, PromotionFromPages } from "../../../models";
import { getImageLink, getImageUrl } from "../../../services/asset";
import { selectAdStatistics } from "../../../routes/Ad/ad.ducks";
import { truncate } from "../../../utils/truncateWord";

const TITLE_MAX_LENGTH = 30;

interface OwnAdBannerProps {
  adId: string;
  title: string;
  imageName: string | null;
}

const OwnAdBanner = ({ adId, title, imageName }: OwnAdBannerProps) => {
  const adStatistics = useSelector(selectAdStatistics);
  const pagePosition = adStatistics && adStatistics.adPagePosition;

  if (!pagePosition || pagePosition <= 1) return null;

  const handleClick = () => {
    ReactGA.event({
      category: "Promocija oglasa",
      action: "Click",
      label: "Aktivacija sa detalja oglasa"
    });
  };

  const backgroundImage = imageName
    ? `url(${getImageLink(imageName)})`
    : `url(${getImageUrl(config.imagePlaceholder)})`;

  return (
    <div className={styles.wrapper}>
      <div className={styles.imageAndTitle}>
        <div className={styles.image} style={{ backgroundImage }} />
        <span>
          {"Tvoj oglas "}
          {title && <strong>{`${truncate(title, TITLE_MAX_LENGTH)} `}</strong>}
          {"se nalazi na "}
          <strong>{`${pagePosition}. stranici`}</strong>
          {" kategorije. Istakni ga i podigni u vrh."}
        </span>
      </div>
      <Link to={`${PageRoute.promote}/${adId}?${START_PAGE_PARAM}=${PromotionFromPages.SingleAd}`} className={styles.buttonLink}>
        <Button type="primary" size="large" className={styles.button} onClick={handleClick}>
          {"Istakni oglas"}
        </Button>
      </Link>
    </div>
  );
};

export default OwnAdBanner;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/OwnAdBanner/index.tsx